import { render, staticRenderFns } from "./topagent.vue?vue&type=template&id=4b721d46"
import script from "./topagent.vue?vue&type=script&lang=js"
export * from "./topagent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports